<script setup>
import BaseIcon from '@/components/Base/BaseIcon.vue';
defineProps({
  title: {
    type: String,
    required: false,
  },
  description: {
    type: String,
    required: false,
  },
  icon: {
    type: String,
    required: false,
  },
  titleClass: {
    type: String,
    required: false,
  },
  bodyClass: {
    type: String,
    required: false,
  },
  iconClass: {
    type: String,
    required: false,
    default: 'border-proxify-gray-50 bg-proxify-gray-100 text-proxify-gray-600',
  },
});
</script>
<template>
  <div class="flex flex-col items-center gap-4 w-[352px]">
    <BaseIcon
      v-if="icon"
      :name="icon"
      size="24px"
      class="p-2 border-8 rounded-full"
      :class="iconClass"
    />
    <div class="flex flex-col gap-1 items-center">
      <div
        class="text-body-md font-semibold text-proxify-gray-900"
        :class="titleClass"
      >
        {{ title }}
      </div>
      <div
        class="text-body-sm text-proxify-gray-600 font-normal"
        :class="bodyClass"
      >
        <slot name="description">
          {{ description }}
        </slot>
      </div>
    </div>
  </div>
</template>
